const { TextField } = require("@mui/material")
const { styled } = require("@mui/system")

export const GrayTextField = styled(TextField)(({theme}) => {
    return ({
        '& label.Mui-focused': {
            color: 'rgba(0,0,0,0.6)'
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(0,0,0,0.6)'
            }
        },
    })
})